import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationMenuComponent } from './operation-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,  
    MatButtonModule,

    RouterModule,
    MatIconModule
  ],
  declarations: [OperationMenuComponent]
})
export class OperationMenuModule { }
